import { useEffect } from 'react'

/**
 * Sets document.title for the current page and restores the previous title on
 * unmount. Used so every route publishes a real page title instead of falling
 * back to the host document's default title.
 */
export function usePageTitle(title: string | undefined) {
  useEffect(() => {
    if (!title) return
    const previousTitle = document.title
    document.title = title
    return () => {
      document.title = previousTitle
    }
  }, [title])
}
